import background from './background';
import inView from './viewport';

export default function heroSlider () {
    const carouselLayouts = document.querySelectorAll('.hero_slider');

    if (!carouselLayouts.length) {
        return;
    }

    carouselLayouts.forEach(layout => {
        const el = layout.querySelector('.swiper');

        if (el === null) {
            return;
        }

        const el_effect = el.getAttribute('data-effect');
        const el_delay = parseInt(el.getAttribute('data-delay'), 10) || 5000;
        const el_autoplay_state = el.getAttribute('data-autoplay');
        let el_autoplay = false;

        if (el_autoplay_state === '1') {
            el_autoplay = { delay: el_delay, disableOnInteraction: false };
        }

        const config = {
            loop: false,
            speed: 700,
            autoplay: el_autoplay,
            spaceBetween: 16,
            slidesPerView: 1,
            autoHeight: true,
            effect: el_effect,
            fadeEffect: { crossFade: true },
            on: {
                init: () => {
                    background();
                },
                slideChange: () => {
                    inView();
                }
            }
        };

        const carousel = new Swiper(el, config);
        const prevButtons = layout.querySelectorAll('.button_prev');
        const nextButtons = layout.querySelectorAll('.button_next');

        prevButtons.forEach(prevButton => {
            prevButton.addEventListener('click', () => {
                carousel.slidePrev();
            });
        });

        nextButtons.forEach(nextButton => {
            nextButton.addEventListener('click', () => {
                console.log(nextButton);
                carousel.slideNext();
            });
        });
    });
}
